import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const OS_VERSION_VIDEO_REPORT_ID = `os-version${VIDEO_CAMPAIGN_SUFFIX}`;
